import styled from 'styled-components';
import { ButtonsContainer } from '@sdk/components/ui/InfoModal/infoInnerModal.styles';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';

export const TemplateEditOptionsModal = styled(InfoModal)`
  ${ButtonsContainer} {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`;
